Vendd.Scripts.load(function () {
    'use strict';

    var load = function () {

        var $form = $(".js-edit-address-form");

        if ($form.length < 1) return;

        var form = $form.get(0);

        var $parentWrapper = $(".x-address-list");

        var addressType = $parentWrapper.data('address-type');

        var $prefectureField, $cityField, $areaField, $addressField, $postCodeField;

        var comboboxWrapperCountry = {}, comboboxWrapperPrefecture = {}, comboboxWrapperCity = {}, comboboxWrapperArea = {}, comboboxWrapperAddressGroup = {},
            comboboxWrapperAddress = {}, comboboxWrapperPostCode = {}, comboboxWrapperTaxAgency = {}, comboboxWrapperVatStatus = {};

        var postCodeChanged = false, fieldsAlreadyValidated = false, autofillChanged = false;

        var model = null, formData, af, countries = [], areas = [], selectedCountry;

        var literalsModel = {}, validationOptions = {};

        var userModel = Vendd.User.GetClientModel();

        form.update = function () {
            var html = Vendd.Handlebars.parse("accountAddressEditBox_A", model);
            form.initFormData();
            form.bind(html);
        };

        form.bind = function (html) {

            $form.html(html);

            $prefectureField = $('.form-row.prefecture', $form);
            $cityField = $('.form-row.city', $form);
            $areaField = $('.form-row.area', $form);
            $addressField = $('.form-row.address1', $form);
            $postCodeField = $('.form-row.postCode', $form);

            literalsModel = model.Literals;

            Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetCountries(model, addressType));
            Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAllAddressGroups(model.GroupId));

            $('.js-required:not(.js-invoice-field)', $form).each(function (e, el) {
                var inputName = $('input, select, textarea', el).attr('name');
                validationOptions[inputName] = {
                    required: inputName + '-required'
                };
            });

            //add phone validation
            if ($('input[name="phone"]', $form).length > 0) {
                validationOptions.phone = validationOptions.phone || {};
                if (venddProjectConfigs.phoneLocalizationEnabled) {
                    validationOptions.phone = { ...validationOptions.phone, ...{ isValidPhoneLocalized: { validator: 'phone-invalid', config: { type: 'phone' } } } };
                } else {
                    if (venddProjectConfigs.Account.RegexPhoneValidation) {
                        validationOptions.phone = { ...validationOptions.phone, ...{ isRegexPhone: { validator: 'phone-invalid', config: { regex: venddProjectConfigs.Account.RegexPhoneValue } } } };
                    } else {
                        validationOptions.phone = { ...validationOptions.phone, ...{ isPhoneNumber: 'phone-invalid' } };
                    }
                }
            }

            //add mobile validation
            if ($('input[name="mobilephone"]', $form).length > 0) {
                validationOptions.mobilephone = validationOptions.mobilephone || {};
                if (venddProjectConfigs.phoneLocalizationEnabled) {
                    validationOptions.mobilephone = { ...validationOptions.mobilephone, ...{ isValidPhoneLocalized: { validator: 'mobilephone-invalid', config: { type: 'mobile' } } } };
                } else {
                    if (venddProjectConfigs.Account.RegexMobileValidation) {
                        validationOptions.mobilephone = { ...validationOptions.mobilephone, ...{ isRegexMobile: { validator: 'mobilephone-invalid', config: { regex: venddProjectConfigs.Account.RegexMobileValue } } } };
                    } else {
                        validationOptions.mobilephone = { ...validationOptions.mobilephone, ...{ isPhoneNumber: 'mobilephone-invalid' } };
                    }
                }
            }

            $form.validationEngine(validationOptions);
            af = $form.data('validationEngine');

            //check if invoice is enable
            if (model.IsInvoice === false || addressType === "shipping") {
                $('.js-invoiceRelated-wrapper', $form).hide();
            } else {
                form.addInvoiceValidation();

                //add readonly property when unique tax is enabled
                if (model.Configs && model.Configs.IsUniqueTaxidentifier && userModel.TaxIdentificationNumber && userModel.TaxIdentificationNumber.length > 0) {
                    $('input[name="taxIdentifier"]', $form).prop("readonly", true);
                }
            }

            if (venddProjectConfigs.phoneLocalizationEnabled) {
                //call public function for phone localization
                initPhoneLocalization();

                if ($('input[name="phone"]', $form).length > 0) {
                    $('input[name="phone"]', $form).get(0).addEventListener("countrychange", function () {
                        var $this = $(this);
                        var fieldName = $this.attr('name');

                        formData[fieldName] = $this.val();
                        af.validateField(fieldName);
                    });
                }
                if ($('input[name="mobilephone"]', $form).length > 0) {
                    $('input[name="mobilephone"]', $form).get(0).addEventListener("countrychange", function () {
                        var $this = $(this);
                        var fieldName = $this.attr('name');

                        formData[fieldName] = $this.val();
                        af.validateField(fieldName);
                    });
                }
            }

            //add postalCode validation only if config parameter is true and selected country has areas
            if (model.Configs.AddressAreaAutoComplete && (selectedCountry && selectedCountry.AreasCount > 1)) {
                form.addPostalCodeValidation();
            }

            //open fancybox
            if (addressType !== 'return') {
                $.fancybox.open($form,
                    {
                        clickSlide: false,
                        clickOutside: false,
                        touch: false,
                        keyboard: false,
                        beforeClose: function (instance, current) {
                            postCodeChanged = false;
                            fieldsAlreadyValidated = false;
                            af.destroy();
                        }
                    }
                );
            }

            $form.show();
        };

        form.initFormData = function () {
            formData = {
                title: model.Title,
                firstName: model.FirstName,
                lastName: model.LastName,
                phone: model.Phones,
                mobilephone: model.Mobiles,
                fax: model.Fax,
                addressLine1: model.AddressLine1,
                addressLine2: model.AddressLine2,
                streetNumber: model.Streetnumber,
                apartment: model.Apartment,
                bell: model.Bell,
                entrance: model.Entrance,
                floor: model.Floor,
                block: model.Block,
                postCode: model.PostCode,
                area: model.Area,
                city: model.City,
                prefecture: model.Prefecture,
                country: model.Country,
                companyName: model.CompanyName,
                headQuarters: model.Headquarters,
                occupation: model.Occupation,
                taxAgency: model.TaxAgency,
                taxAgencyId: model.TaxAgencyId,
                taxIdentifier: model.TaxIdentifier,
                vatStatus: model.VatStatus,
                receiveEinvoice: model.ReceiveEinvoice,
                isInvoice: model.IsInvoice,
                addressGroupId: model.GroupId
            };
        };

        form.resetInvoiceFields = function () {
            formData.taxIdentifier = "";
            formData.taxAgency = "";
            formData.taxAgencyId = null;
            formData.vatStatus = 0;
            formData.companyName = "";
            formData.headQuarters = "";
            formData.occupation = "";
        };

        form.addInvoiceValidation = function () {

            form.addTaxIdentifierValidation();

            if (model.Configs && model.Configs.IsCompanyNameRequired) {
                af.addField({ companyName: { required: 'companyName-required' } });
                af.validate("companyName");
            }

            if (model.Configs && model.Configs.IsOccupationRequired) {
                af.addField({ occupation: { required: 'occupation-required' } });
                af.validate("occupation");
            }

            if (model.Configs && model.Configs.IsTaxAgencyRequired) {
                af.addField({ taxAgency: { required: 'taxAgency-required' } });
                af.validate("taxAgency");
            }

            if (model.Configs && model.Configs.IsHeadquartersRequired) {
                af.addField({ headQuarters: { required: 'headQuarters-required' } });
                af.validate("headQuarters");
            }
        };
         
        form.removeInvoiceValidation = function () {
             
            af.removeField("taxIdentifier");

            if (model.Configs && model.Configs.IsCompanyNameRequired)
                af.removeField("companyName");

            if (model.Configs && model.Configs.IsOccupationRequired)
                af.removeField("occupation");

            if (model.Configs && model.Configs.IsTaxAgencyRequired)
                af.removeField("taxAgency");

            if (model.Configs && model.Configs.IsHeadquartersRequired)
                af.removeField("headQuarters");

            $('input[name = "companyName"], input[name = "occupation"], input[name = "headQuarters"], input[name = "taxAgency"], select[name = "taxAgency"], input[name = "taxIdentifier"]').val("");
            formData.companyName = "", formData.occupation = "", formData.headQuarters = "", formData.taxAgency = "", formData.taxIdentifier = "" ;
        };

        form.addTaxIdentifierValidation = function () {
            af.removeField("taxIdentifier");
            $('.taxIdentifier-invalid', $form).removeClass('error');
            $('.form-row.taxidentifier', $form).removeClass('with-error');

            if (selectedCountry && selectedCountry.IsEUCountry) {
                if (model.Configs.InvoiceAutoComplete) {
                    af.addField({ taxIdentifier: { required: 'taxIdentifier-required', isServiceValidTaxIdentifier: { validator: 'taxIdentifier-invalid', config: { isValid: true } } } });
                } else {
                    af.addField({ taxIdentifier: { required: 'taxIdentifier-required', isGreekTaxIdentifier: 'taxIdentifier-invalid' } });
                }
            } else {
                af.addField({ taxIdentifier: { required: 'taxIdentifier-required' } });
            }

            af.validate("taxIdentifier");

        };

        form.setUniqueTaxidentifier = function () {
            if (model.Configs && model.Configs.IsUniqueTaxidentifier && userModel.TaxIdentificationNumber && userModel.TaxIdentificationNumber.length > 0) {
                //set user specific tax id 
                formData.taxIdentifier = userModel.TaxIdentificationNumber;
                $('input[name="taxIdentifier"]', $form).val(userModel.TaxIdentificationNumber);
                $('input[name="taxIdentifier"]', $form).prop("readonly", true);

                //set user specific tax country
                selectedCountry = countries.filter(function (x) { x.Id === userModel.TaxCountryId })[0];
                formData.country = selectedCountry.Code;
                $('select[name="country"]', $form).val(selectedCountry.Code);
                $('select[name="country"]', $form).prop("disabled", true);

                //call GetVatInfo service if IsEUCountry
                if (model.Configs.InvoiceAutoComplete && selectedCountry && selectedCountry.IsEUCountry) {
                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetVatInfo(formData.country, formData.taxIdentifier));
                }
            }
        };

        form.resetUniqueTaxidentifier = function () {
            if (model.Configs && model.Configs.IsUniqueTaxidentifier && userModel.TaxIdentificationNumber && userModel.TaxIdentificationNumber.length > 0) {
                $('input[name="taxIdentifier"]', $form).prop("readonly", false);
                $('select[name="country"]', $form).prop("disabled", false);
            }
        };

        form.addPostalCodeValidation = function () {
            af.removeField("postCode");
            af.addField({ postCode: { required: 'postCode-required', isValidPostalCode: { validator: 'postCode-invalid', config: { country: formData.country, areas: areas } } } });
            af.validateField("postCode");
        };

        form.removePostalCodeValidation = function () {
            af.removeField("postCode");
            $('.postCode-invalid').removeClass('error');
            //if has class required
            af.addField({ postCode: { required: 'postCode-required' } });
            af.validateField("postCode");
        };

        form.getAutofillData = function (element) {
            if (element === "country") {
                if (model.Configs && model.Configs.IsPrefectureVisible && model.Configs.IsPrefectureAutofill) {
                    $prefectureField.addClass('x-loading');
                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('prefecture', formData.country));
                } else if (model.Configs && model.Configs.IsCityVisible && model.Configs.IsCityAutofill) {
                    $cityField.addClass('x-loading');
                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('city', formData.country, formData.prefecture));
                } else if (model.Configs && model.Configs.IsAreaVisible && model.Configs.IsAreaAutofill) {
                    $areaField.addClass('x-loading');
                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('geoArea', formData.country, formData.prefecture, formData.city));
                } else if (model.Configs && model.Configs.IsAddressLine1Visible && model.Configs.IsAddressLine1Autofill) {
                    $addressField.addClass('x-loading');
                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('StreetNumberCombined', formData.country, formData.prefecture, formData.city, formData.area));
                } else if (model.Configs && model.Configs.IsPostCodeVisible && model.Configs.IsPostCodeAutofill) {
                    $postCodeField.addClass('x-loading');
                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('postalCode', formData.country, formData.prefecture, formData.city, formData.area, formData.addressLine1));
                }
            }

            if (element === "prefecture") {
                if (model.Configs && model.Configs.IsCityVisible && model.Configs.IsCityAutofill) {
                    $cityField.addClass('x-loading');
                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('city', formData.country, formData.prefecture));
                } else if (model.Configs && model.Configs.IsAreaVisible && model.Configs.IsAreaAutofill) {
                    $areaField.addClass('x-loading');
                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('geoArea', formData.country, formData.prefecture, formData.city));
                } else if (model.Configs && model.Configs.IsAddressLine1Visible && model.Configs.IsAddressLine1Autofill) {
                    $addressField.addClass('x-loading');
                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('StreetNumberCombined', formData.country, formData.prefecture, formData.city, formData.area));
                } else if (model.Configs && model.Configs.IsPostCodeVisible && model.Configs.IsPostCodeAutofill) {
                    $postCodeField.addClass('x-loading');
                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('postalCode', formData.country, formData.prefecture, formData.city, formData.area, formData.addressLine1));
                }
            }

            if (element === "city") {
                if (model.Configs && model.Configs.IsAreaVisible && model.Configs.IsAreaAutofill) {
                    $areaField.addClass('x-loading');
                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('geoArea', formData.country, formData.prefecture, formData.city));
                } else if (model.Configs && model.Configs.IsAddressLine1Visible && model.Configs.IsAddressLine1Autofill) {
                    $addressField.addClass('x-loading');
                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('StreetNumberCombined', formData.country, formData.prefecture, formData.city, formData.area));
                } else if (model.Configs && model.Configs.IsPostCodeVisible && model.Configs.IsPostCodeAutofill) {
                    $postCodeField.addClass('x-loading');
                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('postalCode', formData.country, formData.prefecture, formData.city, formData.area, formData.addressLine1));
                }
            }

            if (element === "area") {
                if (model.Configs && model.Configs.IsAddressLine1Visible && model.Configs.IsAddressLine1Autofill) {
                    $addressField.addClass('x-loading');
                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('StreetNumberCombined', formData.country, formData.prefecture, formData.city, formData.area));
                } else if (model.Configs && model.Configs.IsPostCodeVisible && model.Configs.IsPostCodeAutofill) {
                    $postCodeField.addClass('x-loading');
                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('postalCode', formData.country, formData.prefecture, formData.city, formData.area, formData.addressLine1));
                }
            }

            if (element === "address") {
                if (model.Configs && model.Configs.IsPostCodeVisible && model.Configs.IsPostCodeAutofill) {
                    $postCodeField.addClass('x-loading');
                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('postalCode', formData.country, formData.prefecture, formData.city, formData.area, formData.addressLine1));
                }
            }
        };

        form.resetAutofillData = function (element) {
            var emptyModelCity = {}, emptyModelArea = {}, emptyModelAddress = {}, emptyModelPostCode = {};

            if (element === "prefecture") {
                emptyModelCity.Cities = [];
                emptyModelCity.Literals = literalsModel;
                comboboxWrapperCity.updateData(emptyModelCity);

                emptyModelArea.Areas = [];
                emptyModelArea.Literals = literalsModel;
                comboboxWrapperArea.updateData(emptyModelArea);

                emptyModelAddress.Streets = [];
                emptyModelAddress.Literals = literalsModel;
                comboboxWrapperAddress.updateData(emptyModelAddress);

                emptyModelPostCode.PostCodes = [];
                emptyModelPostCode.Literals = literalsModel;
                comboboxWrapperPostCode.updateData(emptyModelPostCode);
            }

            if (element === "city") {
                emptyModelArea.Areas = [];
                emptyModelArea.Literals = literalsModel;
                comboboxWrapperArea.updateData(emptyModelArea);

                emptyModelAddress.Streets = [];
                emptyModelAddress.Literals = literalsModel;
                comboboxWrapperAddress.updateData(emptyModelAddress);

                emptyModelPostCode.PostCodes = [];
                emptyModelPostCode.Literals = literalsModel;
                comboboxWrapperPostCode.updateData(emptyModelPostCode);
            }

            if (element === "area") {
                emptyModelAddress.Streets = [];
                emptyModelAddress.Literals = literalsModel;
                comboboxWrapperAddress.updateData(emptyModelAddress);

                emptyModelPostCode.PostCodes = [];
                emptyModelPostCode.Literals = literalsModel;
                comboboxWrapperPostCode.updateData(emptyModelPostCode);
            }

            if (element === "address") {
                emptyModelPostCode.PostCodes = [];
                emptyModelPostCode.Literals = literalsModel;
                comboboxWrapperPostCode.updateData(emptyModelPostCode);
            }

            autofillChanged = false;
        };

        form.initSelectSearch = function (element) {
            $('select', element).select2({
                dropdownParent: $('.x-address-edit-box')
            });
        };

        comboboxWrapperTaxAgency.updateData = function (taxAgencies) {
            //Add Selected parameter in taxAgencies model
            if (model.TaxAgency) {
                if (taxAgencies.Literals) {
                    taxAgencies.TaxAgency = model.TaxAgency;
                } else {
                    taxAgencies.forEach(function (taxAgency, index) {
                        if (taxAgency.Name === model.TaxAgency) {
                            taxAgencies[index].Selected = true;
                            return;
                        }
                    });
                    model.TaxAgency = null;
                }
            }

            var $comboboxWrapperArea = $(".js-tax-agencies-select", $form);
            var taxAgenciesComboboxHtml = Vendd.Handlebars.parse("accountTaxAgencyCombo_A", taxAgencies);
            $comboboxWrapperArea.html(taxAgenciesComboboxHtml);

            if (formData.isInvoice) {
                if (model.Configs.InvoiceAutoComplete && formData.taxIdentifier && selectedCountry && selectedCountry.IsEUCountry) {
                    //omit script tag before ajax call
                    formData.taxIdentifier = omitScriptTag(formData.taxIdentifier);
                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetVatInfo(formData.country, formData.taxIdentifier));
                }

                if (model.Configs && model.Configs.IsTaxAgencyRequired) {
                    //re-init validation after html parse
                    af.removeField("taxAgency");
                    af.addField({ taxAgency: { required: 'taxAgency-required' } });

                    //validate again taxAgency if fields area already validated
                    if (af.options.taxAgency) af.validate("taxAgency");
                }
            }
        };

        comboboxWrapperVatStatus.updateData = function (vatStatuses) {
            //Add Selected parameter in VatStatuses model
            vatStatuses.forEach(function (vatStatus, index) {
                if (vatStatus.Id === model.VatStatus) {
                    vatStatuses[index].Selected = true;
                    return;
                }
            });

            var $comboboxWrapperArea = $(".js-vat-status-select", $form);
            var vatStatusComboboxHtml = Vendd.Handlebars.parse("accountVatStatusCombo_A", vatStatuses);
            $comboboxWrapperArea.html(vatStatusComboboxHtml);
        };

        comboboxWrapperCountry.updateData = function (countries) {

            //parse html with new model
            var countriesComboboxHtml = Vendd.Handlebars.parse("accountAddressCountryCombo_A", countries);
            var $comboboxWrapperCountry = $(".js-address-countries-select", $form);
            $comboboxWrapperCountry.html(countriesComboboxHtml);

            //re-init validation after html parse
            if (model.Configs && model.Configs.IsCountryRequired) {
                af.removeField("country");
                af.addField({ country: { required: 'country-required' } });
            }

            if (formData.country !== '' || (formData.country === '' && countries.length === 1)) {

                if (formData.country === '') {
                    $('select', $comboboxWrapperCountry).val(countries[0].Code);
                    formData.country = countries[0].Code;
                }

                if (model.Configs && model.Configs.IsTaxAgencyVisible) {
                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAllTaxAgencies(formData.country));
                }

                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAllVatStatuses());

                form.getAutofillData("country");
            }
        };

        comboboxWrapperPrefecture.updateData = function (data) {
            //parse html with new model
            var prefecturesComboboxHtml = Vendd.Handlebars.parse("accountAddressPrefectureCombo_A", data);
            var $comboboxWrapperPrefecture = $(".js-address-prefectures-select", $form);
            $comboboxWrapperPrefecture.html(prefecturesComboboxHtml);

            //re-init validation after html parse
            if (model.Configs && model.Configs.IsPrefectureRequired) {
                af.removeField("prefecture");
                af.addField({ prefecture: { required: 'prefecture-required' } });
            }

            if (model.Configs && model.Configs.IsPrefectureAutofill) {
                var selectedPrefecture = data.Prefectures.find(function (x) { return formData.prefecture === x });

                if (selectedPrefecture || data.Prefectures.length == 1) {
                    $('select', $comboboxWrapperPrefecture).val(selectedPrefecture ? selectedPrefecture : data.Prefectures[0]);
                    formData.prefecture = selectedPrefecture ? selectedPrefecture : data.Prefectures[0];

                    form.getAutofillData("prefecture");
                } else {
                    formData.prefecture = '';
                }
            }

            //validate again prefecture if fields area already validated
            if (af.options.prefecture) af.validate('prefecture');

        };

        comboboxWrapperCity.updateData = function (data) {
            //parse html with new model
            var citiesComboboxHtml = Vendd.Handlebars.parse("accountAddressCityCombo_A", data);
            var $comboboxWrapperCity = $(".js-address-cities-select", $form);
            $comboboxWrapperCity.html(citiesComboboxHtml);

            //re-init validation after html parse
            if (model.Configs && model.Configs.IsCityRequired) {
                af.removeField("city");
                af.addField({ city: { required: 'city-required' } });
            }

            if (model.Configs && model.Configs.IsCityAutofill) {
                var selectedCity = data.Cities.find(function (x) { return formData.city === x });

                if (selectedCity || data.Cities.length == 1) {
                    $('select', $comboboxWrapperCity).val(selectedCity ? selectedCity : data.Cities[0]);
                    formData.city = selectedCity ? selectedCity : data.Cities[0];

                    form.getAutofillData("city");
                } else {
                    formData.city = '';
                }
            }

            //validate again city if fields area already validated
            if (af.options.city) af.validate('city');
        };

        comboboxWrapperArea.updateData = function (data) {
            //parse html with new model
            var partial = model.Configs && model.Configs.IsAreaAutofill ? "accountAddressAreaCombo_B" : "accountAddressAreaCombo_A";
            var areasComboboxHtml = Vendd.Handlebars.parse(partial, data);
            var $comboboxWrapperArea = $(".js-address-areas-select", $form);
            $comboboxWrapperArea.html(areasComboboxHtml);

            //re-init validation after html parse
            if (model.Configs && model.Configs.IsAreaRequired) {
                af.removeField("area");
                af.addField({ area: { required: 'area-required' } });
            }

            if (model.Configs && model.Configs.IsAreaAutofill) {
                var selectedArea = data.Areas.find(function (x) { return formData.area === x });

                if (selectedArea || data.Areas.length == 1) {
                    $('select', $comboboxWrapperArea).val(selectedArea ? selectedArea : data.Areas[0]);
                    formData.area = selectedArea ? selectedArea : data.Areas[0];

                    form.getAutofillData("area");
                } else {
                    formData.area = '';
                }
            }

            //validate again area if fields area already validated
            if (af.options.area) af.validate('area');

            //validate postal code
            if (model.Configs.AddressAreaAutoComplete && (selectedCountry && selectedCountry.AreasCount > 1)) {
                form.addPostalCodeValidation();
            } else {
                form.removePostalCodeValidation();
            }
        };

        comboboxWrapperAddress.updateData = function (data) {
            //parse html with new model
            var streetsComboboxHtml = Vendd.Handlebars.parse("accountAddressStreetCombo_A", data);
            var $comboboxWrapperStreet = $(".js-address-streets-select", $form);
            $comboboxWrapperStreet.html(streetsComboboxHtml);

            //re-init validation after html parse
            if (model.Configs && model.Configs.IsAddressLine1Required) {
                af.removeField("addressLine1");
                af.addField({ addressLine1: { required: 'addressLine1-required' } });
            }

            if (model.Configs && model.Configs.IsAddressLine1Autofill) {
                var selectedStreet = data.Streets.find(function (x) { return formData.addressLine1 === x });

                if (selectedStreet || data.Streets.length == 1) {
                    $('select', $comboboxWrapperStreet).val(selectedStreet ? selectedStreet : data.Streets[0]);
                    formData.addressLine1 = selectedStreet ? selectedStreet : data.Streets[0];

                    form.getAutofillData("address");
                } else {
                    formData.addressLine1 = '';
                }
            }

            //validate again addressLine1 if fields area already validated
            if (af.options.addressLine1) af.validate('addressLine1');
        };

        comboboxWrapperPostCode.updateData = function (data) {
            //parse html with new model
            var postCodesComboboxHtml = Vendd.Handlebars.parse("accountAddressPostCodeCombo_A", data);
            var $comboboxWrapperPostCode = $(".js-address-postcodes-select", $form);
            $comboboxWrapperPostCode.html(postCodesComboboxHtml);

            //re-init validation after html parse
            if (model.Configs && model.Configs.IsPostCodeRequired) {
                af.removeField("postCode");
                af.addField({ postCode: { required: 'postCode-required' } });
            }

            if (model.Configs && model.Configs.IsPostCodeAutofill) {
                var selectedPostCode = data.PostCodes.find(function (x) { return formData.postCode === x });

                if (selectedPostCode || data.PostCodes.length == 1) {
                    $('select', $comboboxWrapperPostCode).val(selectedPostCode ? selectedPostCode : data.PostCodes[0]);
                    formData.postCode = selectedPostCode ? selectedPostCode : data.PostCodes[0];
                } else {
                    formData.postCode = '';
                }
            }

            //validate again addressLine1 if fields area already validated
            if (af.options.postCode) af.validate('postCode');
        };

        comboboxWrapperAddressGroup.updateData = function (addressGroups) {
            // Update 'Selected' attribute in addressGroups model
            if (model.GroupId > 0) {
                addressGroups.Items.forEach(function (addressGroup) {
                    addressGroup.Selected = (addressGroup.Value.Id === model.GroupId);
                });
            }

            var $comboboxWrapperAddressGroups = $(".js-address-group-select", $form);
            var addressGroupsComboboxHtml = Vendd.Handlebars.parse("accountAddressGroupCombo_A", addressGroups);
            $comboboxWrapperAddressGroups.html(addressGroupsComboboxHtml);

            //re-init validation after html parse
            if (model.Configs && model.Configs.IsAddressGroupRequired) {
                af.removeField('addressGroup');
                af.addField({ addressGroup: { required: 'addressGroup-required' } });
            }

            //validate again addressGroup if fields area already validated
            if (af.options.addressGroup) af.validate('addressGroup');
        };

        $form.on('keyup', 'input[name]', function (e) {

            var $this = $(this);
            var fieldName = $this.attr('name');

            if (fieldName === "postCode") {
                removeWhiteSpaces($this);
            }

            formData[fieldName] = $this.val();
            af.validate(fieldName);
        });

        $form.on('blur', 'input[name]', function (e) {
            //validate fields instantly
            if (!fieldsAlreadyValidated) {
                if ($(this).attr('name') === "phone") {
                    af.validateField("phone");
                }

                if ($(this).attr('name') === "mobilephone") {
                    af.validateField("mobilephone");
                }
            }
        });

        $form.on('change', 'select[name]', function (e) {

            var $this = $(this);
            var fieldName = $this.attr('name');

            formData[fieldName] = $this.val();
            af.validate(fieldName);
        });

        $form.on('change', '.js-invoice-address-checkbox', function () {
            if (this.checked) {
                formData.isInvoice = true;
                form.setUniqueTaxidentifier();
                form.addInvoiceValidation();
                $('.js-invoiceRelated-wrapper', $form).show();
            } else {
                formData.isInvoice = false;
                form.resetUniqueTaxidentifier();
                form.removeInvoiceValidation();
                $('.js-invoiceRelated-wrapper', $form).hide();
            }
        });

        $form.on('keyup', 'input[name = "taxIdentifier"]', $.debounce(400, function () {
            if (!model.Configs.InvoiceAutoComplete || formData.taxIdentifier == null || formData.taxIdentifier == '' || !selectedCountry || (selectedCountry && !selectedCountry.IsEUCountry)) {
                af.validateField("taxIdentifier");
                return;
            } else {
                //omit script tag before ajax call
                formData.taxIdentifier = omitScriptTag(formData.taxIdentifier);
                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetVatInfo(formData.country, formData.taxIdentifier));
            }
        }));

        $form.on('click', '.js-submit-button', function (id) {

            var val1 = af.validate();

            if (val1) {

                var einvoiceVal = $("input:radio[name='eInvoice']:checked").val();

                if (einvoiceVal === "true") {
                    formData.receiveEinvoice = true;
                } else if (einvoiceVal === "false") {
                    formData.receiveEinvoice = false;
                } else {
                    formData.receiveEinvoice = null;
                }

                $('input[name]:not([type="checkbox"]):not([type="radio"]), select[name]', $form).each(function () {
                    formData[$(this).attr('name')] = omitScriptTag($(this).val());
                });

                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.CheckAddressIfExists(
                    model.Id,
                    formData.firstName,
                    formData.lastName,
                    formData.addressLine1,
                    formData.addressLine2,
                    formData.city,
                    formData.postCode,
                    formData.country,
                    formData.area,
                    model.IsBilling,
                    model.IsShipping
                ));
            }

            fieldsAlreadyValidated = true;
        });

        $form.on('change', '.js-countries-selector', function (id) {

            selectedCountry = countries.filter(function (x) { return x.Code === formData.country })[0];

            if (model.Configs && (model.Configs.IsPrefectureAutofill || model.Configs.IsCityAutofill || model.Configs.IsAreaAutofill || model.Configs.IsAddressLine1Autofill || model.Configs.IsPostCodeAutofill)) {
                form.getAutofillData("country");
            } else {
                //reset prefecture
                $('input[name=prefecture]').val('');
                //reset city
                $('input[name=city]').val('');
                //reset postal code
                $('.js-postal-code').val('');
                //reset area
                var emptyModelArea = {};
                emptyModelArea.Literals = literalsModel;
                comboboxWrapperArea.updateData(emptyModelArea);
            }

            //if invoice is checked
            if (formData.isInvoice) form.addTaxIdentifierValidation();

            if (model.Configs && model.Configs.IsTaxAgencyVisible) {
                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAllTaxAgencies(formData.country));
            }

            Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAllVatStatuses());

        });

        $form.on('change', '.js-prefectures-selector', function (id) {
            autofillChanged = true;
            form.getAutofillData("prefecture");
        });

        $form.on('change', '.js-cities-selector', function (id) {
            autofillChanged = true;
            form.getAutofillData("city");
        });

        $form.on('change', '.js-areas-selector', function (id) {
            autofillChanged = true;
            form.getAutofillData("area");
        });

        $form.on('change', '.js-streets-selector', function (id) {
            autofillChanged = true;
            form.getAutofillData("address");
        });

        $form.on('select2:open', function (event) {
            var selectId = $(this).find('.select2-selection[aria-owns]').attr('aria-owns');
            $(".select2-search__field[aria-controls=" + selectId + "]").each(function (key, value) {
                value.focus();
            })
        });

        $form.on('keyup', '.js-postal-code', $.debounce(500, function (postcode) {
            if (model.Configs && model.Configs.AddressAreaAutoComplete && !model.Configs.IsAreaAutofill) {
                postCodeChanged = true;
                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAreasForPostCode(formData.country, formData.postCode, formData.area));
            }
        }));

        $form.on('change', '.js-tax-agencies', function (id) {
            model.TaxAgencyId = $('.tax-agencies-select.js-tax-agencies-select select option:selected').data("id");
        });

        $form.on('change', '.js-address-group', function (id) {
            model.GroupId = $('.address-group-select.js-address-group-select select option:selected').data("id");
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.OpenAddressEditForm, form, function (envelope) {
            model = envelope.message.data.model;
            form.update();
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.EditAddressSuccess, form, function (envelope) {
            Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.AddressModelChanged());
            $form.hide();
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetCountriesSuccess, form, function (envelope) {
            countries = envelope.message.data.model;

            selectedCountry = countries.length > 1 ? countries.filter(function (x) { return x.Code === formData.country })[0] : countries[0];
            countries[0].Selected = selectedCountry ? true : false;

            //Fill Countries Combobox
            comboboxWrapperCountry.updateData(countries);

            //add disabled property when unique tax is enabled
            if (model.IsInvoice && model.Configs && model.Configs.IsUniqueTaxidentifier && userModel.TaxIdentificationNumber && userModel.TaxIdentificationNumber.length > 0) {
                $('select[name="country"]', $form).prop("disabled", true);
            }

            if (model.Configs && model.Configs.AddressAreaAutoComplete && !model.Configs.IsCountryAutofill && !model.Configs.IsAreaAutofill && formData.postCode !== '' && formData.postCode !== undefined && (selectedCountry && selectedCountry.AreasCount > 1)) {
                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAreasForPostCode(formData.country, formData.postCode, formData.area));
            }
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAddressInfoSuccess, form, function (envelope) {
            var model = envelope.message.data.model;
            var fields = model.arguments.fields;
            var addressData = model.data;
            var data = {};

            data.Literals = literalsModel;

            //update autofill fields
            if (fields.length <= 1) {
                if (fields[0] === "prefecture") {

                    if (autofillChanged) form.resetAutofillData("prefecture");

                    data.Prefectures = addressData.map(function (obj) { return obj.prefecture; });

                    comboboxWrapperPrefecture.updateData(data);

                    if (venddProjectConfigs.Account.EditForm.PrefectureSearch) form.initSelectSearch($prefectureField);

                    $prefectureField.removeClass('x-loading');

                } else if (fields[0] === "city") {

                    if (autofillChanged) form.resetAutofillData("city");

                    data.Cities = addressData.map(function (obj) { return obj.city; });

                    comboboxWrapperCity.updateData(data);

                    if (venddProjectConfigs.Account.EditForm.CitySearch) form.initSelectSearch($cityField);

                    $cityField.removeClass('x-loading');

                } else if (fields[0] === "geoArea") {

                    if (autofillChanged) form.resetAutofillData("area");

                    data.Areas = addressData.map(function (obj) { return obj.geoArea; });

                    comboboxWrapperArea.updateData(data);

                    if (venddProjectConfigs.Account.EditForm.AreaSearch) form.initSelectSearch($areaField);

                    $areaField.removeClass('x-loading');

                } else if (fields[0] === "StreetNumberCombined") {

                    if (autofillChanged) form.resetAutofillData("address");

                    data.Streets = addressData.map(function (obj) { return obj.StreetNumberCombined; });

                    comboboxWrapperAddress.updateData(data);

                    if (venddProjectConfigs.Account.EditForm.AddressSearch) form.initSelectSearch($addressField);

                    $addressField.removeClass('x-loading');

                } else if (fields[0] === "postalCode") {

                    data.PostCodes = addressData.map(function (obj) { return obj.postalCode; });
                    comboboxWrapperPostCode.updateData(data);

                    if (venddProjectConfigs.Account.EditForm.PostCodeSearch) form.initSelectSearch($postCodeField);

                    $postCodeField.removeClass('x-loading');
                }
            }
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAreasForPostCodeSuccess, form, function (envelope) {
            areas = envelope.message.data.model;

            if (areas.length == 1) {
                formData.area = areas[0].Name;
            }

            if (areas.length > 0) {
                var city = areas[0].City;
                if (city !== "") {
                    if (postCodeChanged || (!postCodeChanged && $(".form-row.city input", $form).val() == "")) {
                        formData.city = city;
                        $(".form-row.city input", $form).val(city);

                        //validate again city if fields area already validated
                        if (af.options.city) af.validate('city');
                    }
                }

                var prefecture = areas[0].Prefecture.Name;
                if (prefecture !== "") {
                    if (postCodeChanged || (!postCodeChanged && $(".form-row.prefecture input", $form).val() == "")) {
                        formData.prefecture = prefecture;
                        $(".form-row.prefecture input", $form).val(prefecture);

                        //validate again city if fields area already validated
                        if (af.options.prefecture) af.validate('prefecture');
                    }
                }
                
                postCodeChanged = false;
            }

            if (areas.length > 0) {
                comboboxWrapperArea.updateData(areas);
            } else {
                var data = {};
                data.Literals = literalsModel;
                comboboxWrapperArea.updateData(data);
            }
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAllTaxAgenciesSuccess, form, function (envelope) {
            if (envelope.message.data.model.length > 0) {
                comboboxWrapperTaxAgency.updateData(envelope.message.data.model);
            } else {
                var data = {};
                data.Literals = literalsModel;
                comboboxWrapperTaxAgency.updateData(data);
            }
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAllVatStatusesSuccess, form, function (envelope) {
            if (envelope.message.data.model.length > 0) {
                comboboxWrapperVatStatus.updateData(envelope.message.data.model);
            } else {
                var data = {};
                data.Literals = literalsModel;
                comboboxWrapperVatStatus.updateData(data);
            }
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetVatInfoSuccess, form, function (envelope) {
            var data = envelope.message.data.model;

            if (data.isValid) {
                if (data.name !== formData.companyName && data.name !== null && data.name !== "") {
                    $('input[name = "companyName"]:text').val(data.name);
                    formData.companyName = data.name;
                    af.validate("companyName");
                }
                if (data.occupation !== formData.occupation && data.occupation !== null && data.occupation !== "") {
                    $('input[name = "occupation"]:text').val(data.occupation);
                    formData.occupation = data.occupation;
                    af.validate("occupation");
                }
                if (data.taxAgency !== formData.taxAgency && data.taxAgency !== null && data.taxAgency !== "") {
                    if ($('select[name="taxAgency"]').length > 0) {
                        $('select[name="taxAgency"] option[data-code=' + data.taxAgencyCode + ']').prop('selected', true);
                        formData.taxAgency = $('select[name="taxAgency"]').val();
                    } else {
                        $('input[name="taxAgency"]').val(data.taxAgency);
                        formData.taxAgency = data.taxAgency;
                    }
                    af.validate("taxAgency");
                }
            } else {
                if (data.error && data.error.message) {
                    $('.taxidentifier .taxIdentifier-invalid', $form).text(data.error.message);
                }
            }

            af.removeField("taxIdentifier");
            af.addField({ taxIdentifier: { required: 'taxIdentifier-required', isServiceValidTaxIdentifier: { validator: 'taxIdentifier-invalid', config: { isValid: data.isValid } } } });
            af.validateField("taxIdentifier");
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAllAddressGroupsSuccess, form, function (envelope) {
            comboboxWrapperAddressGroup.updateData(envelope.message.data.model);
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.CheckAddressIfExistsSuccess, form, function (envelope) {

            if (envelope.message.data.success === false) {
                $('.address-already-exists', $form).show();

            } else {
                $.fancybox.close();
                var check = true;
                try {
                    var addressMatched = JSON.parse(envelope.message.data.data);
                    if (addressMatched.AddressId == -1) check = false;
                } catch (ex) {
                    /* failed to parse json */
                }

                if (check) {

                    //reset invoice fields
                    if (addressType === "shipping" || formData.isInvoice === false) form.resetInvoiceFields();

                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.EditAddress(
                        addressType,
                        model.Id,
                        formData.title,
                        formData.firstName,
                        formData.lastName,
                        formData.phone,
                        formData.mobilephone,
                        formData.fax,
                        formData.addressLine1,
                        formData.addressLine2,
                        formData.streetnumber,
                        formData.apartment,
                        formData.bell,
                        formData.entrance,
                        formData.floor,
                        formData.block,
                        formData.postCode,
                        formData.area,
                        formData.city,
                        formData.prefecture,
                        formData.country,
                        formData.companyName,
                        formData.headQuarters,
                        formData.occupation,
                        formData.taxAgency,
                        formData.taxAgencyId,
                        formData.taxIdentifier,
                        formData.vatStatus,
                        formData.receiveEinvoice,
                        formData.isInvoice,
                        formData.addressGroupId
                    ));
                }
            }

        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.CheckAddressIfExistsFailure, form, function (envelope) { });

        /* messages referring to requestReturnContactValidationForm_A.js - start */
        Vendd.MessageBus.subscribe(Vendd.Account.Messages.ValidateEditControl, form, function (envelope) {
            var val = af.validate();

            if (val) {
                $('input[name]:not([type="checkbox"]):not([type="radio"]), select[name]', $form).each(function () {
                    formData[$(this).attr('name')] = $(this).val();
                });

                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.ValidateEditControlSuccess(val, formData));
            } else {
                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.ValidateEditControlSuccess(val));
            }
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.ResetEditControl, form, function (envelope) {
            af.destroy();
        });
        /* messages referring to requestReturnContactValidationForm_A.js - end */
    };

    // messages referring to requestReturnContactValidationForm_A.js
    Vendd.MessageBus.subscribe(Vendd.Account.Messages.ReloadEditControl, "accountAddressEditForm", function (envelope) {
        //load again control
        load();

        Vendd.MessageBus.publishAsync("accountAddressEditForm", new Vendd.Account.Messages.ReloadEditControlSuccess());
    });

    load();

});
